import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { ZrSwal } from 'utils'

import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

import * as FacturacionService from 'services/facturacion.service'

const portletBreadcrumbs = [{ name: 'Ventas' }]

const tableHeaderRows = [
  { label: 'FECHA', width: 85, align: 'center' },
  { label: 'TIPO', width: 90, align: 'center' },
  {
    label: 'SERIE DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'serDoc'
    }
  },
  {
    label: 'NUM DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'numDoc'
    }
  },
  {
    label: 'RUC',
    width: 100,
    align: 'center'
  },
  { label: 'RAZÓN SOCIAL', align: 'center' },
  { label: '', width: 30, align: 'center' }
]

const ListaVentasPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickDesvincular = React.useCallback(
    ({ _id }) => {
      ZrSwal.showAlert({
        tipo: 'warning',
        mensaje: 'Seguro de desvincular los anticipos del documento?',
        showCerrar: true,
        onSuccess: () => {
          FacturacionService.desvincularAnticiposxId(_id)
            .then(() => {
              __zariContext.snack('success', 'Anticipos desvinculados! Para seguir trabajando en el documento, actualizar manualmente.')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Ventas - Desvincular Anticipo' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Table.ServerSide
          ref={tablaRef}
          useFilters={true}
          useNest={true}
          url='/facturaciones/uso-anticipos'
          headRows={tableHeaderRows}
          rowTemplate={row => (
            <Table.Row hover key={row._id}>
              <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell align='center'>
                {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
              </Table.Cell>
              <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
              <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
              <Table.Cell align='center'>{row.documentoSocio || '--'}</Table.Cell>
              <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickDesvincular({ _id: row._id })}>
                      Desvincular
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default ListaVentasPage
